module.exports = __webpack_public_path__ + "img/settings.e4c9c617.svg";